export class MfHkExportReport {
  id!: number;
  date!: Date;
  dateTo!: Date;
  discountIds!: number[];
}
